import { Helmet } from "react-helmet-async";

export default function SeoHead({ seo }) {
  if (!seo) return null;

  const title = typeof seo?.title === "string" ? seo.title : "";
  const description = typeof seo?.description === "string" ? seo.description : "";
  const robots = typeof seo?.robots === "string" ? seo.robots : "";
  const canonical = typeof seo?.canonical === "string" ? seo.canonical : "";

  const ogTitle = typeof seo?.og?.title === "string" ? seo.og.title : "";
  const ogDescription =
    typeof seo?.og?.description === "string" ? seo.og.description : "";
  const ogImage = typeof seo?.og?.image === "string" ? seo.og.image : "";
  const ogUrl = typeof seo?.og?.url === "string" ? seo.og.url : "";

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Rezervix",
    url: canonical,
    logo: "https://rezervix.ro/images/logo_alb_rezervix.png",
  };

  return (
    <Helmet title={title}>
      {description ? <meta name="description" content={description} /> : null}
      {robots ? <meta name="robots" content={robots} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:type" content="website" />
      {ogTitle ? <meta property="og:title" content={ogTitle} /> : null}
      {ogDescription ? (
        <meta property="og:description" content={ogDescription} />
      ) : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      {ogUrl ? <meta property="og:url" content={ogUrl} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      {ogTitle ? <meta name="twitter:title" content={ogTitle} /> : null}
      {ogDescription ? (
        <meta name="twitter:description" content={ogDescription} />
      ) : null}
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema),
        }}
      />
    </Helmet>
  );
}